import { CdrBreakpointSm, CdrBreakpointMd, CdrBreakpointLg } from '@rei/cdr-tokens';

const getScreenWidth = () => {
  const screen = (window && window.innerWidth) || 0;
  let size;
  if (screen) {
    if ((screen >= parseInt(CdrBreakpointSm, 10)) && (screen < parseInt(CdrBreakpointMd, 10))) {
      size = 'sm';
    } else if ((screen >= parseInt(CdrBreakpointMd, 10))
    && (screen < parseInt(CdrBreakpointLg, 10))) {
      size = 'md';
    } else if (screen >= parseInt(CdrBreakpointLg, 10)) {
      size = 'lg';
    } else if (screen < parseInt(CdrBreakpointSm, 10)) {
      size = 'xs';
    } else {
      size = undefined;
    }
  }

  return size;
};

export default getScreenWidth;
